module.exports = __webpack_public_path__ + "img/candle-holder.8c60094c.svg";